import React from "react";
import Loader from '../Loader';
import './GfyEmbed.scss';

import Waypoint from 'react-waypoint';

class GfyEmbed extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    }
    this.onLoad = this.onLoad.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
  }

  onLoad() {
    this.setState({ loaded: true });
  }

  hide() {
    this.setState({ visible: false, loaded: false });
  }

  show() {
    this.setState({ visible: true });
  }

  render() {
    const { gfy } = this.props;
    const divStyle = {
      position: 'relative',
      paddingBottom: '56.5%',
      height: 0,
      marginTop: '5px',
      marginBottom: '5px'
    }
    return (
      <div style={divStyle}>
      <Waypoint
        onLeave={this.hide}
        onEnter={this.show}
        scrollableAncestor={window}
        topOffset={"-33%"}
        bottomOffset={"-33%"}
      >
      <div className="gfy-iframe-wrapper">
          {
            this.state.visible ?
            <div>
              { !this.state.loaded ? 
                <div className="gfy-iframe-loader-wrapper">
                  <Loader dark />
                </div>
                : null
              }
              <iframe src={`https://gfycat.com/ifr/${gfy.gfy_name}?profile_pic=0`} frameBorder='0' scrolling='no' width='100%' height='267' allowFullScreen onLoad={this.onLoad}></iframe>
            </div>
            : null
          }
      </div>
      </Waypoint>
      </div>
    );
  }

}

export default GfyEmbed;